import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { SpinnerService } from './spinner.service';
import { finalize, map } from 'rxjs/operators';
import { UserService } from './user.service';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
declare var $: any;

const UNAUTHORIZED: number = 401;
@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private activeRequests = 0;
  constructor(
    private _spinner: SpinnerService,
    private _user: UserService,
    private router: Router
  ) { }
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const url = request.url;
    if (url.includes(environment.apiLocalUrl)) {
      const auditoria: Auditoria = {
        UserAgent: $('#userAgent').val(),
        Browser: $('#browser').val(),
        Plataform: $('#so').val(),
      };
      let _navigator = {};
      for (let i in navigator) _navigator[i] = navigator[i];
      _navigator['url'] = document.location.href;
      let pluginList = '';
      for (let i = 0; i < navigator.plugins.length; i++)
        pluginList += navigator.plugins[i].name + ',';
      _navigator['pluginList'] = pluginList.substring(0, pluginList.length - 1);
      request = request.clone({
        setHeaders: {
          Auditoria: JSON.stringify(auditoria),
          Authorization: this.getToken(),
          Navigator: JSON.stringify(_navigator),
          //'Cache-Control': 'private',
          //'X-Frame-Options' : 'SAMEORIGIN',
          //'Content-Security-Policy' : 'default-src',
          //'X-Content-Type-Options' : 'nosniff',
          //'Strict-Transport-Security' : 'max-age = 31536000',
        },
      });
    }
    this.activeRequests++;
    this._spinner.showSpinner();
    return next.handle(request).pipe(
      finalize(() => {
        this.activeRequests--;
        if (this.activeRequests === 0) {
          this._spinner.hiddenSpinner();
        }
      }),
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          if (event.status === UNAUTHORIZED) {
            this._user.deleteUser();
            this.router.navigate(['/log-out']);
          }
        }
        return event;
      })
    );
  }

  getToken(): string {
    if (this._user.getUser()) {
      return 'Bearer ' + this._user.getUser().token;
    }
    return '';
  }
}
interface Auditoria {
  UserAgent: string;
  Browser: string;
  Plataform: string;
}
